import React from 'react';
import './Keyboard.css';

function Keyboard({ validChars, onKeyClick, onBackspace, language }) {
  const validLetters = validChars.letters || new Set();
  const specialChars = validChars.special || new Set();

  const showHyphen = specialChars.has('-');
  const showSpace = specialChars.has(' ');

  const spacebarTranslations = { en: 'SPACE', es: 'ESPACIO', pt: 'ESPAÇO' };
  const spacebarText = spacebarTranslations[language] || 'SPACE';

  const letterRows = [
    ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
    ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
    ['Z', 'X', 'C', 'V', 'B', 'N', 'M']
  ];

  return (
    <div className="keyboard">
      {/* --- Fileira 1: Q-P --- */}
      <div className="keyboard-row">
        {letterRows[0].map(letter => (
          <button key={letter} className="keyboard-key" onClick={() => onKeyClick(letter)} disabled={!validLetters.has(letter)}>
            {letter.toUpperCase()}
          </button>
        ))}
      </div>

      {/* --- Fileira 2: A-L --- */}
      <div className="keyboard-row">
        {letterRows[1].map(letter => (
          <button key={letter} className="keyboard-key" onClick={() => onKeyClick(letter)} disabled={!validLetters.has(letter)}>
            {letter.toUpperCase()}
          </button>
        ))}
      </div>
      
      {/* --- Fileira 3: Z-M + Funções --- */}
      <div className="keyboard-row">
        {showHyphen && (
          <button className="keyboard-key function-key" onClick={() => onKeyClick('-')}>
            -
          </button>
        )}
        
        {letterRows[2].map(letter => (
          <button key={letter} className="keyboard-key" onClick={() => onKeyClick(letter)} disabled={!validLetters.has(letter)}>
            {letter.toUpperCase()}
          </button>
        ))}
        {/* --- MUDANÇA: Ícone SVG substituído por caractere de texto --- */}
        <button className="keyboard-key function-key backspace" onClick={onBackspace}>
          ⌫
        </button>
      </div>

      {showSpace && (
        <div className="keyboard-row">
          <button className="keyboard-key space-key" onClick={() => onKeyClick(' ')}>
            {spacebarText.toUpperCase()}
          </button>
        </div>
      )}
    </div>
  );
}

export default Keyboard;
